import { FeatureIslandMainWithBackGround } from "@/components/features/_layouts";
import { QuestionForMain } from "@/components/features/_layouts/island/main/question";

import { InputTextField } from "@/components/ui/form/fields/input-field/input-text";

import type { HotelSettingsHotelInfoI18nFormModel } from "../../../../model/type";
import type { HotelSettingsHotelInfoI18nFormModelMethodsType } from "../../../../model/usecase/use-create-form-model/methods";

type Props = {
	viewModel: HotelSettingsHotelInfoI18nFormModel["ViewModel"];

	hotelSettingsHotelInfoFormModelMethods: HotelSettingsHotelInfoI18nFormModelMethodsType["hotelSettingsHotelInfoFormModelMethods"];
};

export const HotelSettingsHotelInfoI18nBaseSettingsIsland = ({
	viewModel,
	hotelSettingsHotelInfoFormModelMethods,
}: Props) => {
	return (
		<FeatureIslandMainWithBackGround islandTitle="基本設定">
			<QuestionForMain
				required={true}
				title="施設名"
				inputChildren={
					<InputTextField
						value={viewModel.name?.value}
						errorMessage={viewModel.name?.error}
						handleChange={hotelSettingsHotelInfoFormModelMethods.onSetName}
					/>
				}
			/>
			<QuestionForMain
				required={true}
				title="施設のキャッチコピー"
				guide="入力例 <br />
				・「最果ての旅のオアシス」へようこそ。<br />
				・金沢・香林坊に佇む蒸留所併設のブティックホテル"
				inputChildren={
					<InputTextField
						value={viewModel.catchCopy?.value ?? ""}
						errorMessage={viewModel.catchCopy?.error}
						handleChange={hotelSettingsHotelInfoFormModelMethods.onSetCatchCopy}
					/>
				}
			/>
		</FeatureIslandMainWithBackGround>
	);
};

HotelSettingsHotelInfoI18nBaseSettingsIsland.displayName = "HotelSettingsHotelInfoI18nBaseSettingsIsland";
